<div class="p-5">

  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">account_balance_wallet</mat-icon>
        Transacciones CBPay
        <span *ngIf="total"
          class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
          {{ total }} registros
        </span>
      </h1>
      <span *ngIf="total"
        class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
        {{ total }} registros
      </span>
    </div>
  </div>

  <!-- Filtros -->
  <div class="flex justify-center mb-6">
    <div class="w-full max-w-5xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">

      <div class="text-center mb-6">
        <h3 class="text-lg font-semibold text-gray-700 flex items-center justify-center">
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros de Busqueda
        </h3>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end mb-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Documento</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">badge</mat-icon>
          <input matInput [(ngModel)]="idNumberDestination" placeholder="V12345678">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Desde</mat-label>
          <input matInput [matDatepicker]="fromPicker" [(ngModel)]="from" placeholder="dd/mm/aaaa">
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Hasta</mat-label>
          <input matInput [matDatepicker]="toPicker" [(ngModel)]="to" placeholder="dd/mm/aaaa">
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>

        <div class="flex items-center gap-2 justify-center pb-1">
          <button (click)="loadTransactions()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;" onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px;">search</mat-icon>
            Buscar
          </button>
          <button (click)="exportarExcel()"
            [disabled]="!transactions || transactions.length === 0"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;" onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px;">download</mat-icon>
            XLS
          </button>
          <button (click)="reload()"
            style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;"
            title="Recargar">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">refresh</mat-icon>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Mensaje de error -->
  <div *ngIf="errorMessage"
    style="background: #fee2e2; color: #dc2626; padding: 12px 20px; border-radius: 10px; border: 1px solid #fecaca; text-align: center; margin-bottom: 16px; font-size: 0.85rem; font-weight: 500;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 6px;">error_outline</mat-icon>
    {{ errorMessage }}
  </div>

  <!-- ═══ Tabla Desktop ═══ -->
  <div class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white max-h-[60vh]" *ngIf="dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" class="w-full table-responsive">

      <!-- Columna Transaction ID -->
      <ng-container matColumnDef="transaction_id">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Transaction ID</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono font-bold">
          {{ row.transactionId }}
        </td>
      </ng-container>

      <!-- Columna Tipo -->
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Tipo</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
            [class]="row.tipo === 'paymentCBPayMovilPayWallet' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'">
            {{ getTransactionType(row.tipo) }}
          </span>
        </td>
      </ng-container>

      <!-- Columna ID Usuario -->
      <ng-container matColumnDef="idUsuario">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">ID Usuario</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono font-bold">
          {{ row.data?.infoUsuario?.userId }}
        </td>
      </ng-container>

      <!-- Columna Estado Transaccion -->
      <ng-container matColumnDef="transactionStatus">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Estado Trx</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getStatusBg(row.transaccion?.estado)"
            [style.color]="'white'">
            {{ row.transaccion?.estado?.replaceAll('_', ' ') || 'Sin estado' }}
          </span>
        </td>
      </ng-container>

      <!-- Columna Beneficiario -->
      <ng-container matColumnDef="beneficiario">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">Beneficiario</th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 text-xs font-medium">
          {{ row.data?.infoUsuario?.name }}
        </td>
      </ng-container>

      <!-- Columna Monto -->
      <ng-container matColumnDef="monto">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">Monto</th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.data?.infoUsuario?.amount }}
        </td>
      </ng-container>

      <!-- Columna Documento -->
      <ng-container matColumnDef="documento">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Documento</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.data?.infoUsuario?.idNumberDestino }}
        </td>
      </ng-container>

      <!-- Columna Fecha -->
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Fecha</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-medium">
          {{ row.fecha | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <!-- Columna Estado CBPay -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Estado CBPay</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-1 text-xs font-bold rounded-full"
            [style.background]="row.status ? '#16a34a' : '#dc2626'"
            style="color: white;">
            {{ row.status ? 'Realizada' : 'No enviada' }}
          </span>
        </td>
      </ng-container>

      <!-- Columna Mensaje -->
      <ng-container matColumnDef="mensaje">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold hide-on-mobile">Mensaje</th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 text-xs hide-on-mobile" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          {{ row.mensaje }}
        </td>
      </ng-container>

      <!-- Columna Data -->
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Data</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <button title="Ver data" (click)="showData(row.data)"
            style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-100 transition-colors"></tr>
    </table>
  </div>

  <!-- ═══ Mobile / Tablet Cards (Acordeon) ═══ -->
  <div class="lg:hidden">
    <div *ngIf="dataSource.data.length === 0 && !errorMessage"
      style="text-align: center; padding: 40px 20px;">
      <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">account_balance_wallet</mat-icon>
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones</p>
    </div>

    <div *ngFor="let row of dataSource.data"
      style="border: 1px solid #e5e7eb; border-radius: 10px; overflow: hidden; margin-bottom: 8px;"
      [style.border-color]="expandedCardId === row.id ? '#1C593D' : '#e5e7eb'">

      <!-- Card header -->
      <div (click)="toggleCard(row.id)"
        style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; cursor: pointer; user-select: none;"
        [style.background]="expandedCardId === row.id ? '#f0fdf4' : '#f9fafb'">

        <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap; flex: 1; min-width: 0;">
          <span style="background: #dcfce7; color: #1e5a3f; font-size: 0.7rem; padding: 2px 7px; border-radius: 10px; font-weight: 600;">
            {{ row.transactionId }}
          </span>
          <span class="px-2 py-0.5 rounded-full" style="font-size: 0.65rem; font-weight: 600;"
            [class]="row.tipo === 'paymentCBPayMovilPayWallet' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'">
            {{ getTransactionType(row.tipo) }}
          </span>
          <span class="px-2 py-0.5 rounded-full" style="font-size: 0.65rem; font-weight: 700;"
            [style.background]="row.status ? '#16a34a' : '#dc2626'"
            style="color: white; font-size: 0.65rem; padding: 2px 8px; border-radius: 10px;">
            {{ row.status ? 'Realizada' : 'No enviada' }}
          </span>
          <span style="font-size: 0.7rem; color: #374151; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ row.data?.infoUsuario?.name }}
          </span>
          <span style="font-size: 0.7rem; color: #1e5a3f; font-weight: 700; white-space: nowrap;">
            {{ row.data?.infoUsuario?.amount }}
          </span>
        </div>

        <mat-icon style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease; flex-shrink: 0; margin-left: 4px;"
          [style.transform]="expandedCardId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body -->
      <div *ngIf="expandedCardId === row.id">
        <div style="padding: 12px 16px; background: white;">
          <div class="grid grid-cols-2 gap-x-12 gap-y-1">

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Transaction ID</span>
              <span style="color: #111827; font-weight: 600; font-size: 0.85rem; font-family: monospace;">
                {{ row.transactionId }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID Usuario</span>
              <span style="color: #111827; font-weight: 700; font-size: 0.85rem; font-family: monospace;">
                {{ row.data?.infoUsuario?.userId }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Beneficiario</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.data?.infoUsuario?.name }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Documento</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">
                {{ row.data?.infoUsuario?.idNumberDestino }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
              <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">
                {{ row.data?.infoUsuario?.amount }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.fecha | date:'dd/MM/yyyy' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Estado Trx</span>
              <span class="px-2 py-0.5 text-xs font-bold rounded-full"
                [style.background]="getStatusBg(row.transaccion?.estado)"
                style="color: white;">
                {{ row.transaccion?.estado?.replaceAll('_', ' ') || 'Sin estado' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;" *ngIf="row.mensaje">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Mensaje</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.8rem; word-break: break-all;">
                {{ row.mensaje }}
              </span>
            </div>

          </div>
        </div>

        <!-- Boton accion -->
        <div style="display: flex; gap: 8px; padding: 10px 16px; background: #f9fafb; border-top: 1px solid #f3f4f6;">
          <button (click)="showData(row.data)"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility</mat-icon>
            Ver Data
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Mensaje si no hay datos (desktop) -->
  <div *ngIf="dataSource.data.length === 0 && !errorMessage"
    class="hidden lg:block"
    style="text-align: center; padding: 40px 20px; background: white; border-radius: 12px; border: 1px solid #e5e7eb; margin-top: 8px;">
    <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">search_off</mat-icon>
    <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones para los filtros seleccionados.</p>
  </div>

  <!-- Paginador -->
  <div *ngIf="dataSource.data.length > 0" class="mt-2">
    <mat-paginator #paginator
      [length]="total"
      [pageSize]="limit"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageIndex]="page - 1"
      aria-label="Select page"
      (page)="changePage($event)"
      style="border-radius: 0 0 12px 12px; border: 1px solid #e5e7eb; border-top: none;">
    </mat-paginator>
  </div>

</div>
